import DoubleConfirmationDialog from '../../../../components/DoubleConfirmationDialog';
import Modal from '../../../../components/Modal';

interface Props {
    isOpen: boolean;
    onDelete: () => void;
    onCancel: () => void;
    name: string;
}

export default function ResetModal({ isOpen, onDelete, onCancel, name }: Props) {
    return (
        <Modal isOpen={isOpen} onClose={onCancel} status="error" size="MD_WIDTH">
            <DoubleConfirmationDialog
                title={`Disable integration with ${name}?`}
                onCancel={onCancel}
                onDelete={onDelete}
                buttonLabel="Disable Integration"
            >
                <p>
                    Are you sure you want to remove your credentials and disable this integration? Your previously
                    imported user data will remain.
                </p>
            </DoubleConfirmationDialog>
        </Modal>
    );
}
